module.exports = __webpack_public_path__ + "img/lens-show.32018a80.png";